import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Reveal from 'react-reveal/Reveal'
import cx from 'classnames'
import MaterialIcon from 'material-icons-react'

import './partner-card.scss'




export default class PartnerCard extends Component {

    state = {
        companyName: '',
        expandedCount: 0
    }

    constructor (props) {
        super(props)

        this.fadeInImage = this.fadeInImage.bind(this)

        this.imageRef = React.createRef()
    }

    static getDerivedStateFromProps (nextProps) {
        const companyName = nextProps.props ? nextProps.props.name : ''
        return { companyName }
    }

    fadeInImage () {
        this.imageRef.current.className += ' loaded'
    }

    componentDidMount () {
        if (this.imageRef.current.readyState === 4) {
            this.fadeInImage()
        } else {
            this.imageRef.current.addEventListener('load', this.fadeInImage, false)
        }
    }

    componentWillUnmount () {
        this.imageRef.current.removeEventListener('load', this.fadeInImage, false)
    }

    onContactClick = e => {
        let target = e.target
        if (target.nodeName.toLowerCase() === 'i') target = target.parentNode

        const { companyName } = this.state
        const contactType = target.getAttribute('data-contact-type')
        
        if (contactType === 'mail') {
            window.dataLayer.push({
                'event': 'mailContact',
                'mailContact': companyName
            })

            if (window.ga) {
                window.ga('send', {
                    hitType: 'event',
                    eventCategory: 'Interactions',
                    eventAction: 'clickedMail',
                    eventLabel: companyName
                })
            }
        } else if (contactType === 'phone') {
            window.dataLayer.push({
                'event': 'phoneContact',
                'phoneContact': companyName
            })
            if (window.ga) {
                window.ga('send', {
                    hitType: 'event',
                    eventCategory: 'Interactions',
                    eventAction: 'clickedPhone',
                    eventLabel: companyName
                })
            }
        } else if (contactType === 'website') {
            window.dataLayer.push({
                'event': 'websiteContact',
                'websiteContact': companyName
            })
            if (window.ga) {
                window.ga('send', {
                    hitType: 'event',
                    eventCategory: 'Interactions',
                    eventAction: 'clickedWebsite',
                    eventLabel: companyName
                })
            }
        }
    }

    onExpandClick = e => {
        let { expandedCount } = this.state

        expandedCount += 1
        this.setState({ expandedCount })
    }

    render () {
        const { props } = this.props

        const { imageUrl, name, info } = props
        const { 
            // businessDaysEnd,
            // businessDaysStart,
            // businessHoursEnd,
            // businessHoursStart,
            // languages,
            address,
            category,
            city,
            country,
            mail,
            services,
            telephone,
            website
        } = info

        const idx = this.props.index
        const style = { transitionDelay: `${idx * 0.1}s` }

        const className = cx(
            'partner-card',
            { 'no-email': mail === '' },
            { 'no-telephone': telephone === '' },
            { 'no-website': website === '' },
            { 'expanded': this.state.expandedCount % 2 !== 0 }
        )

        let formatPhone = telephone.substring(2).replace(' ', '')
        formatPhone = telephone ? `+${telephone.substring(2).replace(' ', '')}` : ''

        const location = `${country}, ${city}, ${address}`
                         .replace(new RegExp(' ', 'g'), '+')
                         .replace(new RegExp(',', 'g'), '%2C')
        const locationURL = `https://www.google.com/maps/search/?api=1&query=${location}`

        return (
            <Reveal effect="reveal">
                <div className={className} style={style}>
                    <header className="partner-card-header">
                        <div className="partner-header-meta">
                            <div className="partner-logo">
                                <a 
                                    onClick={this.onContactClick}
                                    data-contact-type="website"
                                    href={website} target="_blank">

                                    <img
                                        ref={this.imageRef}
                                        src={imageUrl}
                                        alt={`${name} Logo`} />

                                </a>
                            </div>
                            <div>
                                <h2>{name}</h2>
                                <h5>{category}</h5>
                            </div>
                        </div>
                        <ul className="services">
                            {services.filter(service => service !== '-' && service !== '').map((service, i) => {
                                return (
                                    <li key={`${service.toLowerCase().replace(' ', '-')}-${i}`}>
                                        <Link to={`/${service.toLowerCase()}/anywhere/1`}>
                                            {service}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </header>
                    <div
                        onClick={this.onExpandClick} 
                        className="expand-collapse">
                        <MaterialIcon icon="expand_more" size={30} />
                    </div>
                    <main className="partner-main">
                        <div className="row-group">
                            <div className="row">
                                <div>{city}, {country}</div>
                            </div>
                            {/*<div className="row">
                                <div>{address}</div>
                            </div>*/}
                        </div>
                        <div className="row-group">
                            <div className="row">
                                <div>
                                    <a 
                                        onClick={this.onContactClick}
                                        data-contact-type="phone"
                                        href={`tel:${formatPhone}`}>
                                        {formatPhone}
                                    </a>
                                </div>
                            </div>
                            <div className="row" style={{whiteSpace: 'nowrap'}}>
                                <div>
                                    <a 
                                        onClick={this.onContactClick}
                                        data-contact-type="mail"
                                        href={`mailto:${mail}`}>
                                        {mail}
                                    </a>
                                </div>
                            </div>
                            <div className="row" style={{whiteSpace: 'nowrap'}}>
                                <div>
                                    <a 
                                        onClick={this.onContactClick}
                                        data-contact-type="website"
                                        href={website} target="_blank">
                                        {website}
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/*<div className="row-group">
                            <div className="row">
                                <div>
                                    {businessDaysStart} - {businessDaysEnd}
                                    <br />
                                    {businessHoursStart} - {businessHoursEnd}
                                </div>
                            </div>
                        </div>*/}
                    </main>
                    <footer className="partner-footer">
                        <a 
                            onClick={this.onContactClick}
                            data-contact-type="phone"
                            href={`tel:${formatPhone}`}>
                            
                            <MaterialIcon icon="local_phone" size={20} />
                            <MaterialIcon icon="local_phone" size={20} />

                        </a>
                        <a  
                            onClick={this.onContactClick}
                            data-contact-type="mail"
                            href={`mailto:${mail}`}>

                            <MaterialIcon icon="email" size={20} />
                            <MaterialIcon icon="email" size={20} />

                        </a>
                        <a 
                            onClick={this.onContactClick}
                            data-contact-type="website"
                            href={website} 
                            target="_blank">
                            <MaterialIcon icon="open_in_new" size={20} />
                            <MaterialIcon icon="open_in_new" size={20} />
                        </a>
                        <a 
                            onClick={this.onContactClick}
                            data-contact-type="location"
                            href={locationURL} 
                            target="_blank">
                            <MaterialIcon icon="location_on" size={20} />
                            <MaterialIcon icon="location_on" size={20} />
                        </a>
                    </footer>
                </div>
            </Reveal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/main/partner-card/index.jsx